import { motion } from "framer-motion";

// Cinematic parallax band featuring the embossed Taurus mark + slogan.
export const LogoBand = () => (
  <section className="relative h-[60vh] min-h-[420px] overflow-hidden bg-tt-black" data-testid="logo-band">
    <motion.div
      initial={{ scale: 1.15 }}
      whileInView={{ scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
      className="absolute inset-0"
    >
      <img src="/assets/horns_emboss.png" alt="" aria-hidden="true" className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-tt-black via-tt-black/40 to-tt-black" />
    </motion.div>

    <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center">
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="font-display text-3xl font-semibold leading-tight sm:text-5xl"
      >
        <span className="metallic-text">Built for the moment</span>{" "}
        <span className="gold-text">the lights go up.</span>
      </motion.p>
      <motion.p
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.15 }}
        className="mt-5 max-w-xl text-sm text-tt-silver/55 sm:text-base"
      >
        Every Taurus app is engineered to perform when it matters most — on stage, in real time, with
        zero room for error.
      </motion.p>
    </div>

    <div className="absolute inset-x-0 top-0 h-px glow-line" />
    <div className="absolute inset-x-0 bottom-0 h-px glow-line" />
  </section>
);
